module.exports = __webpack_public_path__ + "img/zigbee-repeater-md.63fbd956.svg";